import React, {useState} from "react";
import MultiSelect from "./multiSelect";
import CustomSelect from "./customSelect";
import UserRow from "./index";

class Filters extends React.Component {

    state = {
        q: ''
    };


    updateFilter = (e) => {
        let filter = this.props.filter;
        if (e.target.name === 'user_filter'){
            filter.user_status = e.target.value || 'all';
        } else {
            let value = e.target.name;
            let customStatuses = filter.custom_statuses;
            let selectedStatus = 'none';
            if (value === 'none' || value === 'all'){
                selectedStatus = value;
                customStatuses = [];
            } else {
                selectedStatus = 'custom';
                let ind = customStatuses.indexOf(value);
                if (ind < 0) {
                    customStatuses.push(value)
                } else {
                    customStatuses.splice(ind,1)
                }
            }
            filter.custom_statuses = customStatuses;
            filter.test_status = selectedStatus;
        }

        this.props.onChnange(filter);
    };

    onChangeSearch = (e) => {
        this.setState({q: e.target.value});
    };

    onPressEnter = (e) => {
        if(e.key === 'Enter'){
            e.preventDefault();
            this.props.search(e.target.value);
        }
    };


    render() {
        return (
            <div className="grid-x mar-top-20">
                <div className="small-12 users__medium-2 large-2 users__filter small-order-2 users__order-1">
                 <CustomSelect onChange={this.updateFilter} user_status={this.props.filter.user_status}/>
                </div>
                <div className="small-12 users__medium-2 large-2 users__filter small-order-3 users__order-2">
                    <label>
                        <MultiSelect onChange={this.updateFilter} test_status={this.props.filter.test_status}
                                     custom_statuses={this.props.filter.custom_statuses} {...this.props} />
                    </label>
                </div>
                <div className="small-12 users__medium-1 large-1 users__filter users__filter--link small-order-4 users__order-3">
                    <a href={this.props.exportLink} className="gray-link">Export to CSV</a>
                </div>
                <div className="small-12 users__medium-auto large-auto flex-end users__search small-order-1 users__order-4">
                    <div className="search-bars__container">
                        <div className="expanding-search expanding-search--term">
                            <label className="expanding-search__label active" title="search">
                            <span className="small-icon expanding-search__icon expanding-search__icon--magnify magnify" onClick={() => this.props.search(this.state.q)}/>
                            </label>
                            <input type="text" name="searchQuery" autoComplete="off" placeholder="search"
                                   onChange={this.onChangeSearch}
                                   onKeyPress={this.onPressEnter}
                                   className="search-field expanding-search__input active" value={this.state.q}/>
                            <span className="small-icon plus-icon" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
export default Filters;